import * as RX from 'reactxp';
import { ActionType } from './';

export interface Window {
  height: number;
  multiplier?: number;
  width: number;
  menuHeight?: number;
  landscape?: boolean;
}

const defaultState = {
  height: RX.UserInterface.measureWindow().height,
  landscape: false,
  menuHeight: 0,
  multiplier: window && window.screen ? Math.ceil(window.innerWidth / window.screen.availWidth) : 1,
  width: RX.UserInterface.measureWindow().width,
}

const windowReducer = (state: Window = defaultState, action: ActionType) => {
  switch (action.type) {
    case 'WINDOW_RESIZE':
      return {
        ...state,
        height: RX.UserInterface.measureWindow().height,
        landscape: RX.Platform.getType() === 'ios' && RX.UserInterface.measureWindow().height < RX.UserInterface.measureWindow().width, //tslint:disable-line
        multiplier: action.multiplier || state.multiplier,
        width: RX.UserInterface.measureWindow().width,
      };

    case 'MENU_SIZE':
      return {
        ...state,
        menuHeight: action.height,
      };

    default:
      return state
  }
}

export default windowReducer



// WEBPACK FOOTER //
// ./src/reducers/window.ts